import React, { useContext } from 'react'
import Image from '../../../../basic/image'
import CustomizedSwiper from '../../../../basic/CustomizedSwiper'
import _ from "lodash";
import styled from 'styled-components'
import AutodocIconImage from '../../../../static/autodocru.png'
import EmexImage from '../../../../static/emexru.png'
import IsnextImage from '../../../../static/existru.png'
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const Chip = styled.a`
  display: inline-block;
  padding: 13px 18px 11px;
  color: #0054ff;
  text-decoration: none;
  
  &:hover {
    color: white;
    background: rgb(235, 235, 235);
  }
`

const Text = styled.div`
  word-break: break-word;
  white-space: normal;
  display: inline-block;
  vertical-align: middle;
  width: 55%;
  text-transform: uppercase;
  color: rgb(23, 61, 176)
`

function ReasonCard({text, src, containerStyle}) {
  return (
    <div
      style={{
        padding: '25px 50px',
        textAlign: 'left',
        display: 'inline-block',
        ...(containerStyle && containerStyle),
      }}
    >
      <Image
        src={src}
        selectable={false}
        width={'100%'}
        containerStyle={{
          display: 'inline-block',
          border: 'none',
          width: '35%',
          verticalAlign: 'middle',
        }}
      />
      <Text dangerouslySetInnerHTML={{__html: text}}/>
    </div>
  )
}

function Mobile({showPriceListModal, setShowPriceListModal, card}) {
  const currentLanguage = useContext(CurrentLanguageContext);

  return currentLanguage === 'ua' || currentLanguage === 'en' ? null : (
    <div style={{marginTop: 20, width: '80vw'}}>

      <div style={{fontSize: 14, marginTop: 20,}}>
        <div style={{marginBottom: 15}}>
          <div
            style={{
              paddingRight: 12,
              marginBottom: 10,
              marginTop: 40,
              fontSize: 16,
              fontWeight: 800,
            }}
          >
            <TranslateText
              style={{ display: 'inline' }}
              id="buy_on_sites"
              place="left"
            />
          </div>
          <CustomizedSwiper
            options={{slidesPerView: 1}}
            list={[
              <Chip
                href={`https://www.autodoc.ru/man/6594/part/${_.get(card, 'article')}/compatibility`}
                style={{marginRight: 10}}
              >
                <Image src={AutodocIconImage} style={{marginRight: 5,}}/>
              </Chip>,
              <Chip
                href={`https://www.emex.ru/f?detailNum=${_.get(card, 'article')}&brandId=-2732`}
                style={{marginRight: 10}}
              >
                <Image src={EmexImage} style={{marginRight: 5,}}/>
              </Chip>,
              <Chip
                href={`https://exist.ru/Price/?pcode=${_.get(card, 'article')}`}
              >
                <Image src={IsnextImage} style={{marginRight: 5,}}/>
              </Chip>]}
          />
        </div>
      </div>
    </div>
  )
}

export default Mobile


// WEBPACK FOOTER //
// ./src/finwhale/common/item/why/Mobile.js